import { useMsal } from "@azure/msal-react";
import { Spinner, Text, useTheme } from "@fluentui/react";
import { RouterParams } from "App";
import { RootState } from "app/store";
import { appInsights } from "global/Application/AppInsight";
import { loadOpportunityProductAction, saveOpportunityProductDataAction } from "global/Application/dataActions";
import { AppDataSource } from "global/DataSources/AppDataSource";
import { MsalTokenSource } from "global/DataSources/MsalTokenSource";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";

interface IProps {
    children: React.ReactNode;
}

const QuoteRequestContext = (props: IProps): JSX.Element => {

    const theme = useTheme();

    const { instance } = useMsal();
    const tokenSource = new MsalTokenSource(instance);
    const dataSource = new AppDataSource(tokenSource);
    const history = useHistory();

    const state = useSelector((state: RootState) => state);
    const dispatch = useDispatch();

    const { bcbs_opportunityproductid }: RouterParams = useParams();

    /*
    INSERT INTO bcbs_copaycoinoption_config_catego (bcbs_config_categoryid, bcbs_copaycoinoptionid)
    SELECT DISTINCT t.bcbs_config_categoryid, copays.bcbs_copaycoinoptionid
    FROM bcbs_copaycoinoption_config_catego copays
    JOIN bcbs_config_category cat on cat.bcbs_config_categoryid = copays.bcbs_config_categoryid
    CROSS APPLY (SELECT TOP 1 * FROM bcbs_config_category cat2 WHERE cat2.bcbs_name = 'Quote Request') T
    WHERE cat.bcbs_name = 'Medical'
    */


    useEffect(() => {

        if (true) {
            let reload = false;

            if (!reload)
                if (!state.status.snapshotLoading)
                    if (!state?.data?.opportunityProduct)
                        reload = true;

            if (reload) {

                appInsights?.trackEvent({
                    name: 'QuoteRequestContext.useEffect',
                    properties: {

                    }
                });

                if (bcbs_opportunityproductid)
                    dispatch(
                        loadOpportunityProductAction(
                            dataSource,
                            bcbs_opportunityproductid
                        )
                    );
            }
        }
        else {
            console.error("Unexpected flow, snapshotId or accountId was expected.")
        }
    }, []);


    const source = useRef<MessageEventSource | null | any>(null);

    // postMessage handler
    useEffect(() => {

        // example of payload:
        function onMessage(event: MessageEvent) {
            // event.origin ===  'https://bcbsonlinedev.crm.dynamics.com'
            source.current = event.source;

            if (event.data?.action === "save") {
                if (state.data.opportunityProduct)
                    dispatch(saveOpportunityProductDataAction(dataSource));
            }

            // setTimeout(() => {
            //     source.current?.postMessage({ action: "change" }, "*");
            // }, 5000);
        }

        window.addEventListener?.("message", onMessage, false);

        return () => {
            window.removeEventListener("message", onMessage);
        }
    }, [state.data.opportunityProduct]);


    // ctrl+s save
    useEffect(() => {

        const documentOnKeyDown = (e: any) => {
            if ((window.navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey) && e.keyCode === 83) {
                // to prevent browsers default action for page save
                e.preventDefault();

                // focus out, giving slice for data to commit
                if (document.activeElement)
                    //@ts-ignore
                    document.activeElement?.blur?.();
            }
        };

        document.addEventListener("keydown", documentOnKeyDown, false);

        const documentOnKeyUp = (event: KeyboardEvent) => {

            if ((window.navigator.platform.match("Mac") ? event.metaKey : event.ctrlKey) && event.keyCode === 83) {
                event.preventDefault();

                dispatch(saveOpportunityProductDataAction(dataSource));

                console.log('context, servicing shortcut (ctrl+s)');

            };
        }

        document.addEventListener("keyup", documentOnKeyUp, false);

        // document.addEventListener("mousedown", (ev) => {
        //     if (ev.ctrlKey)
        //         setMenuCoordinates({ x: ev.x, y: ev.y });
        // });
        // document.addEventListener("mouseup", (ev) => {

        //     setMenuCoordinates(null);
        // });

        return () => {
            // clear (CTRL + S)
            document.removeEventListener("keyup", documentOnKeyUp);
            document.removeEventListener("keydown", documentOnKeyDown);
        }

    }, []);



    const onRenderChildren = () => {
        return props.children as JSX.Element;
    }

    if (state.status.snapshotLoading)
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '95vh', width: '95vw' }}>
                <Spinner />
            </div>
        );

    if (!state.data.opportunityProduct)
        return (
            <Text>
                Unexpected error, no data was found.
            </Text>
        );

    return onRenderChildren();

};

export default QuoteRequestContext;